/**
 * @author        yewon@zumper.com (Yewon Lee)
 * @copyright     Copyright (c) 2020, Zumper
 * @description   getSelectedFloorplanId
 */

import { selectHasRoomTypeFloorplans } from '@zcode/nr/es/shared/bizos/rentable/selectors'
import {
  selectFirstFloorplanId,
  selectMatchingFloorplanIdByBedrooms,
} from '@zcode/nr/es/shared/bizos/rentable/selectors/floorplans'
import type {
  FloorplanListing,
  Listable,
  NormalFloorplanListingData,
  Property,
} from '@zcode/state-type'

export const getSelectedFloorplanId = (
  entity: Pick<Listable | Property, 'activeFloorplans' | 'floorplans'>,
  selectedFloorplan:
    | Pick<FloorplanListing<NormalFloorplanListingData>, 'isFloorplan' | 'listingId'>
    | undefined,
  filtersBedroom: readonly boolean[]
) => {
  let fpId: number | null | undefined
  if (selectedFloorplan) {
    // floor plan is selected, use listingId of the floor plan
    fpId = selectedFloorplan.listingId
  } else if (entity) {
    if (selectHasRoomTypeFloorplans(entity)) {
      fpId = selectFirstFloorplanId(entity.activeFloorplans)
    } else if (filtersBedroom?.includes(true)) {
      fpId = selectMatchingFloorplanIdByBedrooms(entity?.activeFloorplans, filtersBedroom)
    } else {
      // use the first active floor plan
      const firstNonWaitlistedFloorplanId = entity.activeFloorplans?.find(
        (fp) => !fp.waitlistEnabled
      )?.listingId
      const firstActiveFloorplanId = entity.activeFloorplans?.[0]?.listingId
      fpId = firstNonWaitlistedFloorplanId ?? firstActiveFloorplanId
    }
  }
  // should be a number
  return fpId
}
